import { FileText } from 'lucide-react'
import { AUTH_MODE } from '../api'
import { filePath } from '../files'
import { ContractPdf } from '../files-ui'
import { useLocale } from '../i18n'

/**
 * CTR-5: the signed PDF. The web app opens it from the API with the session's
 * cookies; the iPad app fetches it with its credentials (A1).
 */
export function ContractPdfLink({ code }: { code: string }) {
  const { messages: m } = useLocale()
  if (AUTH_MODE === 'token') return <ContractPdf code={code} />
  return (
    <a
      href={filePath({ kind: 'contract', code })}
      target="_blank"
      rel="noopener"
      className="flex min-h-touch items-center gap-2 self-start"
    >
      <FileText aria-hidden="true" className="size-6" />
      {m.booking.contract.pdf}
    </a>
  )
}
